module.exports = __webpack_public_path__ + "img/ball_7_orange.d542c9d4.png";